import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Input from './Input';
var DefaultValue = {
  value: '',
  point: '•'
};

var Password =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Password, _PureComponent);

  var _super = _createSuper2(Password);

  function Password(props) {
    var _this;

    _classCallCheck(this, Password);

    _this = _super.call(this, props);
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Password, [{
    key: "handleChange",
    value: function handleChange(val) {
      var _this$props = this.props,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? DefaultValue.value : _this$props$value,
          _this$props$point = _this$props.point,
          point = _this$props$point === void 0 ? DefaultValue.point : _this$props$point,
          clearToUndefined = _this$props.clearToUndefined;

      if (val === undefined && clearToUndefined) {
        this.props.onChange(undefined);
        return;
      }

      var newValue = [];
      val.split('').forEach(function (v, i) {
        newValue.push(v === point ? value[i] : v);
      });
      this.props.onChange(newValue.join(''));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$point = _this$props2.point,
          point = _this$props2$point === void 0 ? DefaultValue.point : _this$props2$point,
          _this$props2$value = _this$props2.value,
          value = _this$props2$value === void 0 ? DefaultValue.value : _this$props2$value,
          others = _objectWithoutProperties(_this$props2, ["point", "value"]);

      var transValue = Array.from({
        length: (value || '').length
      }, function () {
        return point;
      }).join('');
      return (
        /*#__PURE__*/
        React.createElement(Input, Object.assign({}, others, {
          type: "text",
          value: transValue,
          onChange: this.handleChange
        }))
      );
    }
  }]);

  return Password;
}(PureComponent);

Password.defaultProps = DefaultValue;
export default Password;